const moment = require('moment');

const getDateDiff = function(startingDate, endingDate) {
  const startDate = moment(startingDate);
  const endDate = moment(endingDate || moment());
  return moment.duration(endDate.diff(startDate));
};

export { getDateDiff };
